// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import CtaSection from "@/components/CtaSection";

export default function ForFoundersPage() {
  return (
    <>
      <section className="section-top">
        <div className="content">
          <div className="block-top">
            <h1 className="heading-top">
              <strong>For Founders &amp; Partners</strong>
            </h1>
            <p className="paragraph-top">We empower founders &amp; partner startups with:</p>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content">
          <div className="w-layout-grid grid-solutions">
            <div id="w-node-c79bbd01-33ca-8c8d-3be4-0725a9fadd9e-99fbab23" className="solutions">
              <img src="/assets/cdn/655f6d0af53c2e7a0f01a4f2_Custom%20Software%20development-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Product Discovery</strong>
              </h2>
              <p className="paragraph-solution">Proven process to ensure repeatable success</p>
            </div>
            <div id="w-node-c79bbd01-33ca-8c8d-3be4-0725a9fadda5-99fbab23" className="solutions">
              <img src="/assets/cdn/655f6c8f63e47b85281882a2_Technology%20Advisory-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Sales &amp; Market Access</strong>
              </h2>
              <p className="paragraph-solution">{"Existing customer base with key decision makers "}</p>
            </div>
            <div id="w-node-c79bbd01-33ca-8c8d-3be4-0725a9faddac-99fbab23" className="solutions">
              <img src="/assets/cdn/655f792573116bba4fb89dff_Product%20Management-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Software Development</strong>
              </h2>
              <p className="paragraph-solution">From building MVPs to ongoing R&amp;D</p>
            </div>
            <div id="w-node-c79bbd01-33ca-8c8d-3be4-0725a9faddb3-99fbab23" className="solutions">
              <img src="/assets/cdn/655f6b9474d7d1f8b5fd1515_UX%20Design-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Funding</strong>
              </h2>
              <p className="paragraph-solution">Providing initial funding and access to investors &amp; angels</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content">
          <div className="block-heading">
            <h2 className="heading _w-100">
              <strong>Areas of Specialization</strong>
            </h2>
            <p className="paragraph-top _w-100">
              We are a focused Venture Studio, prioritizing areas where we can deliver the greatest value through our expertise, market access, and collaboration with our other ventures.
            </p>
          </div>
          <div className="w-layout-grid grid-features">
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8ded-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f21d_lightning.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">AI</h5>
              </div>
              <p className="paragraph-features">Leverage AI to help develop stronger business relationships</p>
            </div>
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8df4-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f219_ibm-cloud-hyper-protect-dbaas.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">Communities</h5>
              </div>
              <p className="paragraph-features">Empowering communities to host better spaces for quality conversations</p>
            </div>
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8dfb-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f21c_container-registry.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">Events</h5>
              </div>
              <p className="paragraph-features">Empowering events to provide better networking opportunities</p>
            </div>
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8e02-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f21a_headset.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">Gamification (new)</h5>
              </div>
              <p className="paragraph-features">Using gamification to create habit-forming products</p>
            </div>
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8e09-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f21b_ibm-watson-machine-learning.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">Sales</h5>
              </div>
              <p className="paragraph-features">Helping sales to develop their relationships with future clients</p>
            </div>
            <div id="w-node-_91f72d7a-9462-cdec-f93b-3f983a3b8e10-99fbab23" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655c5d4d25d668c29fb0f218_ibm-cloud-hyper-protect-crypto-services.svg" loading="eager" alt="" className="icon-features hide" />
                <h5 className="heading-features">HR</h5>
              </div>
              <p className="paragraph-features">Helping HRs to build better relationships with candidates</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="w-layout-blockcontainer content w-container">
          <div className="block-post large">
            <div id="w-node-_586bba35-cc41-e0ce-a8eb-608844bce558-99fbab23" className="link-post-thumbnail large">
              <img src="/assets/cdn/6560754329a29f98b1cace33_Pricing.webp" loading="lazy" sizes="(max-width: 767px) 87vw, (max-width: 1279px) 47vw, 600px" srcSet="/assets/cdn/6560754329a29f98b1cace33_Pricing-p-500.webp 500w, /assets/cdn/6560754329a29f98b1cace33_Pricing.webp 800w" alt="Hand sketching a growth chart" className="image-post-thumbnail large" />
            </div>
            <div id="w-node-_45304a64-8646-6617-7e9c-8f719ea36168-99fbab23" className="post large">
              <div className="link-heading-post large">
                <h3 className="heading-post">
                  <strong>Partnership with our Ventures</strong>
                </h3>
              </div>
              <p>
                Our Venture Studio is unique in its focused approach, concentrating on a select few areas. This specialization allows us to:
                <br />
                <br />
                • Share in-depth know-how across our ventures, as they often address similar needs in different contexts, creating a strong foundation of expertise.
                <br />
                <br />
                • Offer targeted market access by identifying and engaging overlapping customer personas, making it easier for ventures to penetrate the market effectively.
                <br />
                <br />
                • Foster partnerships among our ventures, where their offerings complement each other to deliver a more comprehensive, value-driven solution for customers.
                <br />
                <br />
                By narrowing our focus, we aim to maximize the chances of success for each venture, driving them toward sustainable, impactful results.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="w-layout-blockcontainer content w-container">
          <div className="block-post large">
            <div id="w-node-_2b79773d-8b55-460a-9f86-59748eec2471-99fbab23" className="post large">
              <div className="link-heading-post large">
                <h3 className="heading-post">
                  <strong>About our Venture Studio model</strong>
                </h3>
              </div>
              <div className="w-richtext">
                <p>
                  As a Venture Studio, we typically hold between 15% and 50% equity in our ventures, depending on their stage and our level of involvement. Unlike the traditional VC model, our approach involves deep, active participation in the venture&#x27;s daily operations.
                </p>
                <p>‍</p>
                <p>Typically, a venture studio:</p>
                <ul role="list">
                  <li>
                    Provides substantial operational support, from product discovery and market access to development, depending on the venture&#x27;s specific needs
                  </li>
                  <li>
                    Acts as a co-founder, leveraging resources and expertise to jumpstart growth and navigate early challenges.
                  </li>
                  <li>
                    Offers strategic funding to facilitate a strong initial launch, adapting support based on the venture’s unique goals.
                  </li>
                </ul>
                <p>
                  This hands-on model ensures ventures are well-positioned to achieve sustainable success right from the start.
                </p>
              </div>
            </div>
            <div id="w-node-_2b79773d-8b55-460a-9f86-59748eec246f-99fbab23" className="link-post-thumbnail large">
              <img src="/assets/cdn/6564780744ca0efa0a7e6d77_Delivery-Center.webp" loading="lazy" sizes="(max-width: 767px) 87vw, (max-width: 1279px) 47vw, 600px" srcSet="/assets/cdn/6564780744ca0efa0a7e6d77_Delivery-Center-p-500.webp 500w, /assets/cdn/6564780744ca0efa0a7e6d77_Delivery-Center-p-800.webp 800w, /assets/cdn/6564780744ca0efa0a7e6d77_Delivery-Center.webp 1000w" alt="Modern glass office building" className="image-post-thumbnail large" />
            </div>
          </div>
        </div>
      </section>
      <CtaSection />
    </>
  );
}
